import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import {
  ComponentType,
  DeviceDTO,
  ILinkableObject,
  Slot,
} from '@/../client-generator/generated-clients/plants';
import SlotItemOverview from '../SlotItem/SlotItemOverview.vue';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';

@Options({
  name: 'DeviceSlotsList',
  props: {
    device: {
      type: Object as PropType<DeviceDTO>,
      required: true,
    },
    slotList: {
      type: Object as PropType<Slot[]>,
      required: true,
    },
    linkableObject: {
      type: Object as PropType<ILinkableObject>,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    ruleServiceType: {
      type: Number,
      default: -1,
    },
  },
  components: {
    SlotItemOverview,
  },
})
export default class DeviceSlotsListOverview extends Vue {
  device!: DeviceDTO;
  slotList!: Slot[]; //use this instead device.slots, because might be filtered by outside if slot are not compatible
  linkableObject!: ILinkableObject;
  isAdd!: boolean;
  ruleServiceType!: SlotRuleServiceType;
  slotsThatExceed = 0;

  get filteredSlotList(): Slot[] {
    const slotToShow = this.slotList.filter((s) => !s.isSetting);
    if (slotToShow.length > 14) {
      this.slotsThatExceed = slotToShow.length - 14;
      return slotToShow.slice(0, 14);
    }
    return slotToShow;
  }
}
